import { TimelineMax, Bounce, TweenLite, Power2, Power0 } from "gsap";
import { SanSymbolData } from "../../../engine/Symbol/SanSymbolData";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { SpinePlayer } from "../../../proto/SpinePlayer";

class DudeSpine extends SpinePlayer{

    private mode:string = "";

    private activeState:boolean = false;
    private hidden:boolean = false;

    private startDelay:number = 0;

    private get switchAnimationState():string{
        return this.animations[Math.floor(Math.random()*this.animations.length)%this.animations.length];
    }

    constructor(){
        super("dudes");
        this.visible = true;
        this.startDelay = 0.3 + Math.random();
    }

    public playDude(value:boolean):void{
        if(this.activeState == value || this.hidden) return;
        this.activeState = value;
        if(value){
            this.play({name:this.mode, loop:true,delay:this.startDelay})

            if(this.startDelay > 0) this.startDelay =0;
        } else
            this.stop();
    }

    public changeDude():void{
        this.hidden = Math.random() > 0.63;
        this.visible = !this.hidden;
        this.mode = this.switchAnimationState;
        this.stop();
    }
}

class Dude extends Sequence {

    private dudeTypes:string[] = ["walking","bench"]
    private mode:number = 0;
    
    private moveTl:TimelineMax = new TimelineMax();

    private activeState:boolean = false;

    private hidden:boolean = false;

    private get createDude():PIXI.Texture[]{
        this.mode = Math.floor(Math.random()*this.dudeTypes.length)%this.dudeTypes.length;
        return GameResources.getTextures(this.dudeTypes[this.mode]+"Dude");
    }

    constructor(){
        super({textures:[]})
        this.setTexture(this.createDude);
    }

    public playDude(value:boolean):void{
        if(this.activeState == value && this.moveTl || this.hidden) return;
        this.moveTl = Helper.timeLineKiller(this.moveTl,new TimelineMax({repeat:-1}));
        this.activeState = value;
        if(value){
            if(this.mode == 0) {
                this.moveTl.fromTo(this.scale,0.1,{x:-1},{x:1,ease:Power0.easeIn},0);
                this.moveTl.fromTo(this.position,3,{x:-50},{x:50,ease:Power0.easeIn},0);
                this.moveTl.fromTo(this.scale,0.1,{x:1},{x:-1,ease:Power0.easeIn},3);
                this.moveTl.to(this.position,3,{x:-50,ease:Power0.easeIn},3);
                this.moveTl.startTime(Math.random()*3)
            }else
                this.position.set(0,0);
            this.playAnimation({repeat:-1, duration: MathHelper.frameToSeconds(this.textures.length)*2 });
            this.timeline?.play(Math.random())
        } else
            this.stop();
    }

    public changeDude():void{
        this.hidden = Math.random()*5 > 3.5;
        this.visible = !this.hidden;
        this.setTexture(this.createDude);
    }
}

export class RevealerBar extends PIXI.Container {

    protected source_core_path:string = "Blocks/";

    protected openEase:any = CustomEase.create("barOpen", "M0,0 C0,0 0.017,0.05923 0.03452,0.0674 0.05798,0.07834 0.09868,0.06172 0.13589,0.06337 0.15398,0.06417 0.17636,0.0618 0.18403,0.07404 0.29662,0.25364 0.3972,0.46468 0.53823,0.7052 0.56583,0.75227 0.5866,0.77732 0.62137,0.81986 0.67628,0.88704 0.71309,0.93149 0.76917,0.98772 0.78129,0.99988 0.79643,1.01014 0.8117,1.01073 0.845,1.01202 0.87691,0.99561 0.91578,0.9934 0.9469,0.99162 1,1 1,1 ");

    protected seq_bar:Sequence;
    protected seq_bar_overlay:Sequence;

    protected text:PIXI.Text;

    protected barPath:string = "";

    private maskElement:PIXI.Graphics;

    protected _timeLine:TimelineMax;
    protected _rezTimeline:TimelineMax;

    private dude:DudeSpine;
    private isTop:boolean = false;

    constructor (path:string){
        super();
        this.barPath = path;
        this.isTop = path === "Block_Top_Bars";
        this.init();
    }

    protected init():void{

        this.dude = this.addChild(new DudeSpine());

        this.seq_bar = this.createSeq(GameResources.getTextures(this.source_core_path + this.barPath));

        this.seq_bar_overlay = this.createSeq(GameResources.getTextures(this.source_core_path + this.barPath));
        this.seq_bar_overlay.blendMode = PIXI.BLEND_MODES.ADD;
        this.seq_bar_overlay.alpha = 0;

        this.maskElement = this.createGraphic();
        this.maskElement.alpha = 0.00000001;

        this.dude.changeDude();
        this.dude.playDude(true);

        this.dude.position.set(0,this.isTop ? this.seq_bar.height/2 : -this.seq_bar.height/2);
    }

    private createGraphic(grow:boolean = false):PIXI.Graphics{
        const graphicBg:PIXI.Graphics =  new PIXI.Graphics();

        const c:number = 0x000000;
        graphicBg.beginFill(c, 1);

        const recTop:number = this.isTop ? 0 : -this.seq_bar.height;
        const recHeight:number = this.seq_bar.height;

        graphicBg.drawRect(-SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5, !this.isTop && grow ? -recHeight : recTop,
             SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH, recHeight);

        graphicBg.endFill();

        this.addChild(graphicBg);
        return graphicBg;
    }

    private createSeq(texture?:PIXI.Texture[]):Sequence{
        const seq:Sequence =  Sequence.createSequence(texture);
        seq.alpha = 1;
        seq.anchor.set(0.5,this.isTop ? 0 : 1);
        this.addChild(seq);
        return seq;
    }

    public open():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax({
            onStart:() => {
                this.mask = this.maskElement;
            },
            onComplete:() => { 
                this.mask = null!;
                this.visible = false;
            }
        }));
        this._timeLine.fromTo(this.seq_bar_overlay,0.15,{alpha:0.5},{alpha:0});
        this._timeLine.add([
            TweenLite.to(this.seq_bar.position,0.30,{x:(SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH), ease:this.openEase}),
            TweenLite.to(this.dude,0.30,{alpha:0, ease:this.openEase}),
        ]);
        this._timeLine.add(() => this.dude.playDude(false));
        return this._timeLine;
    }

    public close():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax({ onStart:() => {
            this.mask = this.maskElement;
            this.visible = true;
        }}));
        
        this.dude.changeDude();
        this.dude.playDude(true);
        this._timeLine.add([
            TweenLite.to(this.seq_bar.position,0.25,{x:0}),
            TweenLite.to(this.dude,0.25,{alpha:1})
        ]);
        return this._timeLine;
    }
}